import React from 'react';
import { Upload, Icon, message } from 'antd';
import download from '../util/fileDownload';

class Document extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fileList: [],
            application: null,
            docType: ''
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const {application, docType} = nextProps;
        if ((prevState.application && application !== prevState.application && nextProps.document.id) ||
            (prevState.application && application === prevState.application && nextProps.document.id) ||
            (!prevState.application && nextProps.document.id)) {
            const {id: uid, file: {original_file_name: name, status = 'done'}, isFetching} = nextProps.document;
            return { loading: isFetching, application, docType, fileList: [{
                uid,
                name,
                status,
                url: `/api/documents/${uid}`
            }]};
        }

        if (prevState.application &&
            application === prevState.application &&
            nextProps.document.id &&
            prevState.fileList.length
        ) {
            return null;
        }

        return {loading: false, fileList: [], application, docType};
    }
    handleChange(info) {
        if (info.file.status === 'uploading') {
            this.setState({ loading: true });
        }
    }

    render() {
        const {label, name, docType: doc_type, onUpload, onRemove} = this.props;
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">{label}</div>
            </div>
        );
        const onPreview = (file) => {
            const {url, name} = file;
            return download(url, name);
        };
        const {fileList} = this.state;
        return (
            <Upload
                name={name}
                data={{doc_type}}
                className="gc-uploader"
                fileList={fileList}
                customRequest={onUpload}
                onChange={this.handleChange.bind(this)}
                onPreview={onPreview}
                onRemove={onRemove}
            >
                {fileList.length ? null : uploadButton}
            </Upload>
        );
    }
}

export default Document;


// WEBPACK FOOTER //
// ./resources/assets/js/components/Document.js